import React from 'react';

export const FlagESIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 600 400" // Standard 3:2 ratio
    {...props}
  >
    <rect width="600" height="400" fill="#F1BF00" rx="2"/> {/* Yellow (main field, 1/2 height) */}
    <rect width="600" height="100" fill="#AA151B" /> {/* Red stripe (top, 1/4 height) */}
    <rect y="300" width="600" height="100" fill="#AA151B" /> {/* Red stripe (bottom, 1/4 height) */}
    {/* Simplified Coat of Arms (towards hoist) */}
    <g transform="translate(150 200) scale(0.8)">
      {/* Crown placeholder */}
      <path d="M-20 -30 L0 -50 L20 -30 L0 -20 Z" fill="#FFD700" />
      <rect x="-25" y="-20" width="50" height="15" fill="#C60B1E" rx="3"/>
      {/* Shield placeholder (simple quartered) */}
      <rect x="-20" y="-5" width="40" height="50" fill="#F1BF00" stroke="#78080E" strokeWidth="3"/>
      <line x1="-20" y1="20" x2="20" y2="20" stroke="#78080E" strokeWidth="3"/>
      <line x1="0" y1="-5" x2="0" y2="45" stroke="#78080E" strokeWidth="3"/>
       {/* Pillars of Hercules placeholder */}
      <rect x="-35" y="-10" width="10" height="50" fill="#B0B0B0" rx="2"/>
      <rect x="25" y="-10" width="10" height="50" fill="#B0B0B0" rx="2"/>
    </g>
     <rect width="600" height="400" fill="none" stroke="#6b7280" strokeOpacity="0.3" strokeWidth="1" rx="2"/>
  </svg>
);